import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';



const AccountBlockedPage: React.FC = () => {
  
  return (
    <Box className="base-container" >          
      <VStack className='simple-box' top={{ base: "200px", sm: "233px" }} >
        <Text
          className='title-text-big'
          textAlign="center"
        >
          Your account has been suspended
        </Text>        
        <Text className='subtitle-text-center' >
          To know why your account was suspended, contact us via contact@gmail.com
        </Text>        
      </VStack>
    </Box>
  );
};

export default AccountBlockedPage;
